var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"co-sugestoes"},[_c('iframe',{staticClass:"iframe",attrs:{"src":"https://azcronos.com.br/sugestoes/?categoria=9","loading":"eager","id":"iframe"}}),(_vm.loading)?_c('basic-loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }